import React from 'react';

import {
  Edit,
  ShowContext,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Form } from 'components/form/Form';
import { yupResolver } from '@hookform/resolvers/yup';
import { MobileFooter } from 'components/mobile-footer/MobileFooter';
import { ShowContainer } from 'components/detail/show-container/ShowContainer';

import { Content } from './components/content/Content';
import { TransactionsHeader } from './components/transactions-header/TransactionsHeader';
import { CancelModal } from './components/cancel-modal/CancelModal';
import { ActionButton } from './components/action-button/ActionButton';
import { UpdateTodoModal } from './components/update-todo-modal/UpdateTodoModal';
import { projectForm } from '../validators/cgp-transaction.validator';

export const CGPTransactionsShow: React.FC = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  const onError = (err: unknown) => {
    notify((err as Error).message, { type: 'error' });
  };
  const onSuccess = () => {
    notify(translate('project.form.success'), { type: 'success' });
    refresh();
  };

  return (
    <ShowContainer
      component="div"
      emptyWhileLoading
      data-testid="transaction-show-container"
    >
      <ShowContext.Consumer>
        {({ record }) => (
          <Edit
            component="div"
            resource="transactions-cgp"
            id={record.id}
            mutationMode="pessimistic"
            mutationOptions={{
              onError,
              onSuccess,
            }}
            actions={false}
          >
            <Form
              shouldUnregister
              resolver={yupResolver(projectForm)}
              record={record}
            >
              <TransactionsHeader actionButtons={<ActionButton />} />
              <Content />
              <MobileFooter>
                <ActionButton />
              </MobileFooter>
            </Form>
          </Edit>
        )}
      </ShowContext.Consumer>

      <CancelModal />
      <UpdateTodoModal />
    </ShowContainer>
  );
};
